// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"3134a86a","80":"74f5d47b","168":"744c4efb","260":"ea7f7b71","482":"4897a57e","672":"b803b6a1","840":"642e18d9","872":"caeeeb1d","956":"81856d58"}[chunkId] + ".chunk.js";
};